import Reactotron from "reactotron-react-js";
import { reactotronRedux } from "reactotron-redux";

const reactotron = Reactotron.configure()
  .use(reactotronRedux())
  .connect(); // let's connect!

reactotron.clear();
export default reactotron;
